module.exports = " <div :class=\"[isCenter ? 'layout-center-set' : 'layout-set']\" :style=layoutSty _v-98607376=\"\"> <slot _v-98607376=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-98607376!./~/vue-loader/lib/selector.js?type=template&index=0!./src/xman/indicator-cause/indicator-layout/index.vue
// module id = 319
// module chunks = 0